import { ID } from "@libs/interfaces/layouts";
import { IUser } from "@/settings/zustand";
import { IProject } from "../interfaces";

export default function getSchoolUniqUsers (schoolId: ID, allProjectsList: IProject[] ) {
    let uniqUsers:  (IUser | undefined)[] = [] 
    let usrs: (IUser | undefined)[] = [] 
    allProjectsList
        .filter((project: IProject) => {
            const school = project.fmru_school[0]
            return school?.id === schoolId
        })
        .forEach((project: IProject) => { 
            usrs = [
                project.leader,
                project.member0,
                project.member1,
                project.member2,
                project.member3,
                project.member4,
                project.member5,
                project.member6,
                project.member7,
                project.member8,
                project.member9,
            ]
            .filter(user => !!user?.id)
            .filter(user => {
                return !uniqUsers.find(usr => usr?.id === user?.id && !!user?.id)
            })
            uniqUsers = [
                ...uniqUsers,
                ...usrs
            ]
        }) 
    return uniqUsers;// as IUser[]
}